// Contact.js
import React, { useState } from 'react';
import API from '../api';
function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [responseMsg, setResponseMsg] = useState("");
  const [error, setError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post('/api/contact', { name, email, message });
      setResponseMsg("Votre message a été envoyé avec succès.");
      setError("");
      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de l'envoi du message.");
      setResponseMsg("");
    }
  };
  return (
    <div className="contact-container">
      <h2>Contactez-nous</h2>
      {error && <p className="error">{error}</p>}
      {responseMsg && <p className="success">{responseMsg}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nom complet :</label>
          <input
            type="text"
            placeholder="Votre nom complet"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Adresse Email :</label>
          <input
            type="email"
            placeholder="Votre adresse email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Message :</label>
          <textarea
            placeholder="Saisissez votre message ici..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows="6"
            required
          ></textarea>
        </div>
        <button type="submit" className="action-button">Envoyer</button>
      </form>
    </div>
  );
}
export default Contact;
